// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7e9e642","453":"f9de5b5e","732":"4985242b","977":"bc108b25"}[chunkId] + ".chunk.js";
};